// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"148":"664320effe3389ae","8393":"73bc04abaeaf6054","8854":"92f310932eb402f9"}[chunkId] + ".css";
};